import PreviewRegForm from "./previewRegForm.container";

export default PreviewRegForm;
